export const ROUTES = {
	// These constants are used when constructing URLs
	// (for example when redirecting to another page)
	root: "/",
	user: {
		register: "/user/register",
		registerV2: "/user/register-v2",
		login: "/user/login",
		logout: "/user/logout",
		forgotPassword: "/user/forgot-password",
		passwordResetRequested: "/user/password-reset-requested",
		resetPassword: "/user/reset-password",
		passwordResetCompleted: "/user/password-reset-completed",
		createReferralCode: "/user/create-referral-code",
		otpRequested: "/user/otp-requested",
	},
	company: {
		onboard: {
			stage1: "/company/onboard/find-address",
			stage2: "/company/onboard/fuel-type",
			stage3: "/company/onboard/contract-type",
			stage4: "/company/onboard/consent",
			completed: "/company/onboard/completed",
		},
		onboardV2: {
			stage1: "/company/onboard-v2/find-address",
			stage2: "/company/onboard-v2/review",
		},
		portal: {
			index: "/company/portal",
			site: "/company/portal/site/:siteId",
			tariffOffers: "/company/portal/site/tariff/:tariffId/offers",
			new: {
				site: {
					stage1: "/company/portal/new/site/:siteId/find-address",
					stage2: "/company/portal/new/site/:siteId/consent",
				},
				contract: {
					stage1: "/company/portal/new/site/:siteId/contract/information",
					stage2: "/company/portal/new/site/:siteId/contract/consent",
				},
			},
		},
		settings: {
			index: "/company/settings",
			personalInfo: "/company/settings/personal-info",
			changePassword: "/company/settings/change-password",
			companyInfo: "/company/settings/company-info",
			consentDocuments: "/company/settings/consent-documents",
			flexibleAssets: "/company/settings/flexible-assets",
			otherUtilities: "/company/settings/other-utilities",
			notifications: "/company/settings/notifications",
			account: "/company/settings/account",
		},
		support: {
			index: "/company/support",
			reportProblem: "/company/support/report-problem",
		},
		create: "/company/create",
		switch: "/company/switch",
	},
	supplier: {
		marketplace: {
			index: "/supplier/marketplace",
			bundle: "/supplier/marketplace/bundle/:bundleId",
			downloadBundleData: "/supplier/marketplace/bundle/:bundleId/bundle-data",
		},
		myBundles: "/supplier/my-bundles",
		settings: {
			index: "/supplier/settings",
			personalInfo: "/supplier/settings/personal-info",
			changePassword: "/supplier/settings/change-password",
			companyInfo: "/supplier/settings/company-info",
			account: "/supplier/settings/account",
			notifications: "/supplier/settings/notifications",
			autoBidding: "/supplier/settings/auto-bidding",
		},
	},
	webhooks: {
		registerSignedAmbassadorLOAForSite:
			"/webhooks/register-signed-ambassador-loa/site/:siteId",
	},
};

export const DNO_REGIONS: { [key: number]: string } = {
	10: "Eastern Power Networks",
	11: "East Midlands",
	12: "London Power Networks",
	13: "SP Manweb",
	14: "West Midlands",
	15: "Northeast",
	16: "Electricity North West",
	17: "Scottish Hydro Electric Power Distribution plc",
	18: "SP Distribution",
	19: "South Eastern Power Networks",
	20: "Southern Electric Power Distribution plc",
	21: "South Wales",
	22: "South West",
	23: "Yorkshire",
};

export const BID_HISTORY_POLL_INTERVAL_MS = 10_000;

export const SUPPORT_EMAIL = "support@tarifftribe.co.uk";
export const WHATSAPP_LINK = "https://wa.me/447943618328";

// In GBP
export const COMMISSION_RATES = {
	gas: 0.007,
	electricity: 0.008,
	both: 0,
};

export const REFERRERS = [
	"Energie Fitness",
	"Miss Millie's",
	"Esquires Coffee",
	"Tariff Tribe",
];
